var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 21C25.6569 21 27 19.6569 27 18C27 16.3431 25.6569 15 24 15C22.3431 15 21 16.3431 21 18C21 19.6569 22.3431 21 24 21Z",
    fill: "#181933"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 3C15.7294 3 9 9.43594 9 17.3438C9 21.1097 10.7166 26.1178 14.1019 32.2294C16.8206 37.1362 19.9659 41.5734 21.6019 43.7812C21.8783 44.1585 22.2397 44.4653 22.6569 44.6768C23.074 44.8882 23.5351 44.9984 24.0028 44.9984C24.4705 44.9984 24.9316 44.8882 25.3487 44.6768C25.7659 44.4653 26.1273 44.1585 26.4038 43.7812C28.0369 41.5734 31.185 37.1362 33.9038 32.2294C37.2834 26.1197 39 21.1116 39 17.3438C39 9.43594 32.2706 3 24 3ZM24 24C22.8133 24 21.6533 23.6481 20.6666 22.9888C19.6799 22.3295 18.9108 21.3925 18.4567 20.2961C18.0026 19.1997 17.8838 17.9933 18.1153 16.8295C18.3468 15.6656 18.9182 14.5965 19.7574 13.7574C20.5965 12.9182 21.6656 12.3468 22.8295 12.1153C23.9933 11.8838 25.1997 12.0026 26.2961 12.4567C27.3925 12.9108 28.3295 13.6799 28.9888 14.6666C29.6481 15.6533 30 16.8133 30 18C29.9983 19.5908 29.3656 21.1159 28.2407 22.2407C27.1159 23.3656 25.5908 23.9983 24 24Z",
    fill: "#181933"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7876b98391e53cab77bc5560eeba5c65.svg";
export { ForwardRef as ReactComponent };